var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluxDisconnectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1107 3.90292C2.15228 4.34495 2.34229 4.77564 2.68076 5.11411L4 6.43335V9H6.56665L8.56665 11H3.2C2.5 11 2 10.3 2 9.4V4.6C2 4.34836 2.03909 4.11236 2.1107 3.90292ZM6.15588 3L8.15588 5H20V9H19.876C20.5822 9.39189 21.2229 9.88756 21.7775 10.4664C21.973 10.1857 22.1 9.81402 22.1 9.4V4.6C22 3.7 21.5 3 20.8 3H6.15588ZM10 6.84412L9.15588 6H10V6.84412ZM11 13.4333V18.5556C11 19.9061 13.1939 21 15.8889 21C16.7485 21 17.5572 20.8887 18.2599 20.6933L17.2371 19.6705C16.8362 19.7373 16.386 19.7778 15.8889 19.7778C13.5239 19.7778 12.2222 18.8611 12.2222 18.5556V17.1928C13.1149 17.6252 14.259 17.8917 15.5041 17.9374L14.1054 16.5388C13.3433 16.3757 12.6823 16.1112 12.2222 15.775V14.6556L11 13.4333ZM19.171 16.0151C19.3109 15.9399 19.4396 15.8597 19.5556 15.775V14.0578C19.0842 14.3239 18.5001 14.5396 17.8404 14.6845L16.7773 13.6214C18.5778 13.4332 19.5556 12.7093 19.5556 12.4444C19.5556 12.1389 18.2539 11.2222 15.8889 11.2222C15.3722 11.2222 14.9062 11.266 14.4935 11.3376L13.4741 10.3183C14.1864 10.1157 15.0105 10 15.8889 10C18.59 10 20.7778 11.0939 20.7778 12.4444V17.6219L19.171 16.0151ZM5 7.43335L5.56665 8H5V7.43335ZM8.58152 13H3.2C2.5 13 2 13.7 2 14.6V19.4C2 20.3 2.5 21 3.2 21H9.75463C9.27238 20.3984 8.87526 19.7257 8.58152 19H4V15H8.06189C8.14901 14.3014 8.32622 13.6307 8.58152 13ZM7 18H5V16H7V18Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 2,
    height: 27,
    rx: 1,
    transform: "rotate(-45 2 3)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluxDisconnectedIcon);
export default __webpack_public_path__ + "static/media/influx-disconnected-icon.3a0f031125b97b161a793813f044f48a.svg";
export { ForwardRef as ReactComponent };